module.exports = __webpack_public_path__ + "static/media/after-fes.10727b3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/after-fes.jpg
// module id = 386
// module chunks = 4